import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { CourierService } from 'src/app/shared/services/courier.service';
import { UserService } from 'src/app/shared/services/user.service';
import { CourierDetailComponent } from '../courier-detail/courier-detail.component';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-courier-list',
  templateUrl: './courier-list.component.html',
  styleUrls: ['./courier-list.component.css']
})
export class CourierListComponent implements OnInit {

  thisData : MatTableDataSource<any>;
  displayColumn : string[];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  @Input() mode : boolean;
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();

  dialogConfig = new MatDialogConfig();
  constructor(
    public userService : UserService,
    private service : CourierService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialog : MatDialog
     ) {

      console.log("CourierListComponent : mode = " + this.mode);

      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "50%";
      this.dialogConfig.minWidth = "400px";
      this.dialogConfig.maxWidth = "600px";

      if(this.userService.isAdminRole())
      {
        this.displayColumn = ['name', 'description', 'actions'];
      }
      else
      {
        this.displayColumn = ['name', 'description'];
      }
    }

  ngOnInit() {
    this.refreshList();
  }

  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this courier?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "Courier Delete");
        this.gnotify.showSnackBar('Courier Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
    this.service.getList().subscribe(
      res => {
        let array = res as CategoryModel[];
        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;

        console.log("refreshList : " + this.thisData.data.length);

        this.applyFilter();

       },
       err =>{
         console.log(err);
       }
    );

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {
    if(this.searchKey != null)
      this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onCreate()
  {
    this.service.initializeFormGroup();

    this.dialogConfig.data = {
           result : false
    };

    let dialogRef = this.dialog.open(CourierDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        this.refreshList();
      }

    });
  }

  onEdit(row){
    this.service.populateForm(row);

    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(CourierDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {

        this.refreshList();
      }

    });
  }
  onSelect(row : any)
  {
    this.onSelected.emit(row);
  }


}
